import {Theme} from "@dspworkplace/ui";
import DatePicker from "../../../components/Calendar/picker";
import {Combobox} from "../../../components/Form/Combobox";
import React from "react";

const useEditorControls = ({row, column, onRowChange, onClose}) => {
    const commitChanges = (value) => {
        row[column.key] = value;
        onRowChange({...row, [column.key]: value}, true);
        onClose();
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === 'Tab') {
            if (false === e.target.validity.valid) {
                e.preventDefault();
                e.stopPropagation();
                e.target.reportValidity();
                return;
            }

            commitChanges(e.target.value);
        }
    }

    const autoFocusAndSelect = (input) => {
        if (!input)
            return;

        input.focus();
        input.select();
    }

    return {
        commitChanges,
        handleKeyDown,
        autoFocusAndSelect
    }
}

export const SmallTextEditor = (props) => {
    const {handleKeyDown, autoFocusAndSelect} = useEditorControls(props);

    return (
        <input
            type='text'
            ref={autoFocusAndSelect}
            style={{
                color: Theme.colors.neutrals.gray,
                fontFamily: 'inherit',
                width: '100%',
                height: '100%',
                padding: '0 8px'
            }}
            defaultValue={props.row[props.column.key]}
            onKeyDown={handleKeyDown}
        />
    )
}

export const EmailEditor = props => {
    const {handleKeyDown, autoFocusAndSelect} = useEditorControls(props);

    return (
        <input
            ref={autoFocusAndSelect}
            type='email'
            style={{
                color: Theme.colors.neutrals.gray,
                fontFamily: 'inherit',
                width: '100%',
                height: '100%',
                padding: '0 8px'
            }}
            defaultValue={props.row[props.column.key]}
            onKeyDown={handleKeyDown}
        />
    )
}

export const DateEditor = props => {
    const {commitChanges} = useEditorControls(props);

    return (
        <div className={'date-editor'}>
            <DatePicker
                defaultValue={props.row[props.column.key]}
                onChange={commitChanges}
                autoFocus
                name={`${props.column.key}_${props.row._INDEX}`}
                input={'MM/DD/YYYY'}
                output={'MM/DD/YYYY'}
            />
        </div>
    )
}

export const DropdownEditor = props => {
    const {commitChanges} = useEditorControls(props);

    return <>
        <Combobox
            size={'full'}
            initialValue={props.row[props.column.key]}
            startOpen={true}
            isAdd={false}
            onChange={opt => commitChanges(opt?.value)}
            options={props.column._dropdown.options}
        />
    </>
}